<template>
  <div
    class="carousel-block"
    :class="{
      'carousel-block--haspagination': numberOfItemsRef > 0,
      'carousel-block--contained': isContained,
      'carousel-block--full': !isContained,
    }"
  >
    <div class="layout-row">
      <div
        v-if="numberOfItemsRef > 0"
        ref="splideElmRef"
        class="splide splide-carousel"
        aria-label="Splide Basic HTML Example"
        :style="{ visibility: numberOfItemsRef === 1 ? 'visible' : '' }"
      >
        <div class="splide__track">
          <slot></slot>
        </div>
        <div
          v-if="numberOfItemsRef > 1"
          class="layout-container carousel-block__arrows"
        >
          <div class="splide__arrows splide__arrows--custom">
            <button class="splide__arrow splide__arrow--prev">
              <i class="icon" :class="`icon-${arrowIconClassModifier}left`" />
            </button>
            <button class="splide__arrow splide__arrow--next">
              <i class="icon" :class="`icon-${arrowIconClassModifier}right`" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Splide from '@splidejs/splide';
import { onMounted, ref, useSlots } from 'vue';
const slots = useSlots();
const numberOfItemsRef = ref(slots.default()[0].children.length);
const isLessThanDesktop = window.matchMedia(`(max-width: 991px)`);
const splideElmRef = ref();

const props = defineProps({
  type: {
    type: String,
    default: 'loop',
  },
  isContained: {
    type: Boolean,
    default: false,
  },
  perPage: {
    type: Number,
    default: 1,
  },
  perMove: {
    type: Number,
    default: 1,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  arrowIconClassModifier: {
    type: String,
    default: 'arrow',
  },
  mobileFirst: {
    type: Boolean,
    default: false,
  },
  breakpoints: {
    type: Object,
    default: null,
  },
});

const init = () => {
  if (splideElmRef.value && numberOfItemsRef.value > 1) {
    const options = {
      perPage: props.perPage,
      perMove: props.perMove,
      arrows: numberOfItemsRef.value > 1,
      destroy: props.disabled || numberOfItemsRef.value < props.minumumSlides,
      mediaQuery: props.mobileFirst ? 'min' : 'max',
      speed: 500,
      flickPower: 100,      

      breakpoints: props.breakpoints || {
        992: {
          arrows: false,
        },
      },
    };

    if (!isLessThanDesktop.matches) {
      options.speed = 800;
      options.easing = 'cubic-bezier(.58,0,.47,.98)';
    }

    requestAnimationFrame(() => {
      new Splide(splideElmRef.value, options).mount();
    });
  }
};

onMounted(() => {
  requestAnimationFrame(init);
});
</script>
